import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import mainApi from '../lib/api';

/**
 * Fetches the current tenant's branding from /api/settings/branding once the
 * user is authenticated and applies the colors/font as CSS variables on <html>.
 *
 * Variables set:
 *   --brand-primary
 *   --brand-accent
 *   --brand-background
 *   --brand-font
 *
 * Consumed by CSS in Layout/Header/Login for live white-label.
 * Skipped on the /super-admin/* stack (that has its own dark theme).
 */
export default function BrandingProvider() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;
    if (window.location.pathname.startsWith('/super-admin')) return;

    mainApi.get('/settings/branding').then(({ data }) => {
      const b = data?.branding || {};
      const root = document.documentElement;
      if (b.primary_color) root.style.setProperty('--brand-primary', b.primary_color);
      if (b.accent_color) root.style.setProperty('--brand-accent', b.accent_color);
      if (b.background_color) root.style.setProperty('--brand-background', b.background_color);
      if (b.font_family) root.style.setProperty('--brand-font', b.font_family);
      // Store tenant name + logo for header component
      if (data?.tenant_name) {
        window.__nis2ai_tenant_name = data.tenant_name;
      }
      if (b.logo_base64) {
        window.__nis2ai_tenant_logo = b.logo_base64;
      }
      if (b.tagline) {
        window.__nis2ai_tenant_tagline = b.tagline;
      }
      // Dispatch event so components (header, login) can re-render
      window.dispatchEvent(new CustomEvent('nis2ai:branding-loaded', { detail: { branding: b, tenant_name: data?.tenant_name } }));
    }).catch(() => {});
  }, [isAuthenticated]);

  return null;
}
